import React, { useState } from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Tooltip from '../../../Tooltip';
import CollapsibleSlot from '../../../CollapsibleSlot';

const CollapsibleExclusionsList = ({
  count,
  tooltipText = 'Entities that do not have advanced data, or do not fit your current datapoint or preference selections will not be included in this export.',
  children,
}) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div className={cx('collapsible-exclusions-list', isOpen && 'open')}>
      <header className="collapsible-exclusions-list__header">
        <span className="hicon-angle-right-new toggle-button" onClick={() => setOpen(!isOpen)} />
        <span>
          {count} {count === 1 ? 'entity' : 'entities'} not included in export{' '}
        </span>
        <Tooltip content={tooltipText} colorVariant="light">
          <span className="hicon-question-circle text-16 text-muted" />
        </Tooltip>
      </header>
      <CollapsibleSlot show={isOpen} animationType="" className="collapsible-exclusions-list__body">
        {children}
      </CollapsibleSlot>
    </div>
  );
};

CollapsibleExclusionsList.propTypes = {
  count: T.number.isRequired,
  tooltipText: T.string,
  children: T.node.isRequired,
};

export default CollapsibleExclusionsList;
